var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.v.form[_vm.name].$dirty && _vm.v.form[_vm.name].$invalid)?_c('div',{staticClass:"was-validated"},_vm._l((Object.keys(_vm.textValidations)),function(error,index){return _c('div',{key:index,staticClass:"invalid-feedback"},[_vm._v(" × "+_vm._s(_vm.textValidations[error])+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }